import styles from "./styles.module.scss";

const ScoreProgress = ({ score = 60 }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.label}>Your Score</span>
        <span className={styles.value}>{score}</span>
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${score}` }}
        />
      </div>
    </div>
  );
};

export default ScoreProgress;